import {Grid} from '@mui/material';
import {useEffect, useState} from 'react';
import {InfoCard} from '../components/InfoCard';
import { AtencionesPorProducto } from '../widgets/AtencionesPorProducto';
import { useEstadisticasCRM } from '../hooks/useEstadisticasCRM';
import { EstadisticasCRM } from '../../bussines/entities/EstadisticasCRM.entity';
import { CardClientesSinContacto } from '../widgets/CardClientesSinContacto';
import { ProductosPorEstado } from '../widgets/ProductosPorEstado';

export const CRMScreen: React.FC<{}> = ({}) => {
   const today = new Date();
   const {getEstadisticasCRM} = useEstadisticasCRM();
   const [estadisticasCRM, setEstadisticasCRM] = useState<EstadisticasCRM | null>(null);
   const fetchEstadisticasCRM = async () => {
      const result = await getEstadisticasCRM({fecha: today});
      if (result) {
         setEstadisticasCRM(result);
      }
   };
   useEffect(() => {
      fetchEstadisticasCRM();
   }, []);

   return (
      <Grid container spacing={2}>
         <Grid item container xs={12} spacing={2}>
            <Grid item sx={{width: '20%'}}>
               <InfoCard
                  descripcion="Clientes Activos"
                  value={estadisticasCRM?.clientesActivos || 0}
               />
            </Grid>
            <Grid item sx={{width: '20%'}}>
               <InfoCard
                  descripcion="Llamadas en el Mes"
                  value={estadisticasCRM?.numeroLlamadas || 0}
               />
            </Grid>
            <Grid item sx={{width: '20%'}}>
               <InfoCard
                  descripcion="Productos vendidos en el Mes"
                  value={estadisticasCRM?.productosVendidos || 0}
               />
            </Grid>
            <Grid item sx={{width: '20%'}}>
               <InfoCard
                  descripcion="Soportes en el Mes"
                  value={estadisticasCRM?.numeroSoportes || 0}
               />
            </Grid>
            <Grid item sx={{width: '20%'}}>
               <CardClientesSinContacto fecha={today} />
            </Grid>
         </Grid>
         <Grid container item xs={12} spacing={2}>
            <Grid item xs={6}>
               <AtencionesPorProducto fecha={today} />
            </Grid>
            <Grid item xs={6}>
               <ProductosPorEstado fecha={today} />
            </Grid>
         </Grid>
      </Grid>
   );
};
